import { createTheme } from "@mui/material/styles"
import { getEnvConfig } from "../config/envConfig"
import { setTransparency } from "../utils/alphaUtils"
import { convertColor } from "../utils/colorUtils"

export const buildTheme = mode => {
  const cfg = getEnvConfig(mode)

  return createTheme({
    palette: {
      mode,
      primary: { main: cfg?.primary ?? "", contrastText: cfg?.contrast ?? "" },
      secondary: {
        main: cfg?.secondary ?? "",
        contrastText: cfg?.contrast ?? ""
      },
      tertiary: {
        main: cfg?.tertiary ?? "",
        contrastText: cfg?.contrast ?? ""
      },
      quaternary: {
        main: cfg?.quaternary ?? "",
        contrastText: cfg?.contrast ?? ""
      },
      background: {
        default: cfg?.background ?? "",
        paper: cfg?.paper ?? ""
      },
      text: {
        primary: cfg?.textPrimary ?? "",
        secondary: cfg?.textSecondary ?? ""
      }
    },
    shape: { borderRadius: 3 },
    typography: { fontFamily: "Inter, Roboto, sans-serif" },
    utils: { convertColor, setTransparency },
    components: {
      MuiButton: {
        styleOverrides: {
          contained: ({ ownerState, theme }) => {
            const color =
              ownerState.color === "primary"
                ? theme.palette.primary.main
                : theme.palette.secondary.main
            const luminance = parseInt(color.replace("#", ""), 16)

            const isLight = luminance > 0x888888
            return {
              color: isLight ? "#0d0d0" : "#fff"
            }
          }
        }
      }
    }
  })
}
